export default "__VITE_ASSET__a6b47b65__"